import React, { Component } from 'react'
import { DropTarget } from 'react-dnd'
import * as ItemTypes from '@disco/constants/ItemTypes'
const target = {
  hover(props) {
    if (!props.sidebarOpen) props.toggleSidebar()
  },

  canDrop() {
    return false
  },
}

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    draggedItem: monitor.getItem(),
  }
}

type Props = {
  isOver: boolean
  sidebarOpen: boolean
  toggleSidebar: (...args: Array<any>) => any
  children: React.ReactNode
  connectDropTarget: (...args: Array<any>) => any
}

class SidebarDropWrapper extends Component<Props> {
  render() {
    const { connectDropTarget } = this.props
    return connectDropTarget(<div>{this.props.children}</div>)
  }
}

export default DropTarget(
  [ItemTypes.TRACK, ItemTypes.PLAYLIST, ItemTypes.GROUP],
  target,
  collect,
)(SidebarDropWrapper) as any
